import { useState } from "react";

export function Tooltip({
  children,
  content,
}: {
  children: React.ReactNode;
  content: string | React.ReactNode;
}) {
  const positionClass = "top-[calc(-100%-10px)] left-1/2 -translate-x-1/2";
  const [open, setOpen] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {open && (
        <div
          className={`bg-gray-200 whitespace-nowrap rounded-sm border-1 px-2 py-1 border-black absolute z-10 ${positionClass}`}
        >
          {content}
        </div>
      )}
      {children}
    </div>
  );
}
